import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkupProfileAction } from '../markupProfile.action';

type IDependencies = IClientApiDependencySegment;

export const removeMarkupProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(MarkupProfileAction.remove.started),
  mergeMap((params) => {
    return dependencies.api.deleteMarkupProfile(params).pipe(
      mergeMap(() => {
        return [
          MarkupProfileAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          MarkupProfileAction.remove.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
